import { call, put } from "redux-saga/effects";
import { courseAPI } from "@services/api";
import {
  checkSavedCourseActions,
  exploreCourseActions,
  saveCourseActions,
} from "../slices";
import { showFailureToast } from "@helpers";

function* updateSaveStatus(payload, isSave) {
  if (isSave) {
    yield put(checkSavedCourseActions.markSaved());
  } else {
    yield put(checkSavedCourseActions.markUnsaved());
  }
  yield put(
    exploreCourseActions.updateSaveStatus({
      ...payload,
      isSave,
    })
  );
}

function* saveCourseWorker({ payload }) {
  try {
    yield put(saveCourseActions.pending(payload));
    yield call(updateSaveStatus, payload, true);
    const response = yield call(courseAPI.saveCourse, payload.courseId);
    yield put(saveCourseActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(saveCourseActions.failure(error));
    yield call(updateSaveStatus, payload, false);
    yield call(showFailureToast, error?.message || "Saving course was failed!");
    // TODO: handle callback | onFailure
  }
}

export { saveCourseWorker };
